import {styled} from '@mui/material/styles';

export const Spacer = styled('div')(({theme}) => ({
    height: theme.spacing(3),
}));
